"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const UICheck_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/UICheck.vue"));
const trans_1 = require("@common/tsutils/trans");
let MetadataModal = class MetadataModal extends vue_property_decorator_1.Vue {
    get missing() {
        return this.csv.hasMissingTypes();
    }
    get listTypes() {
        return ['boolean', 'list', 'number', 'date'].map(t => ({
            value: t,
            label: (0, trans_1.trans)('heatmap.types.' + t),
        }));
    }
    checkAll() {
        const allChecked = this.csv.fields.every(f => f.selected);
        this.csv.fields.forEach(f => f.selected = !allChecked);
    }
    onChangeType(field) {
        if (field.type) {
            field.selected = true;
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], MetadataModal.prototype, "csv", void 0);
MetadataModal = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            UICheck: UICheck_vue_1.default
        }
    })
], MetadataModal);
exports.default = MetadataModal;
